module.exports = __webpack_public_path__ + "img/egg_spirals_happy.6e987735.svg";